import { useTranslation } from '@/shared/i18n/use-translation';
import { Skeleton } from '@/shared/ui/skeleton/skeleton';

type ListSkeletonProps = {
  readonly rows?: number;
};

const KEYS = ['a', 'b', 'c', 'd', 'e', 'f'];

export function ListSkeleton({ rows = 4 }: ListSkeletonProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2" role="status" aria-busy="true" aria-label={t('Loading')}>
      {KEYS.slice(0, rows).map((key) => (
        <Skeleton key={key} className="h-16 rounded-xl" />
      ))}
    </div>
  );
}
